import type { ComponentPropsWithoutRef, Ref } from 'react';
import { forwardRef } from 'react';

import { TimeIntervalsInMilliseconds } from '@shared/constants/timeIntervals';
import { useSqrTokenPriceQuery } from '@shared/hooks/query/token';

import { Sqr } from '@ui/uikit/components/icons/poly/Sqr';
import { cn, formatUsd } from '@ui/uikit/utils';

export type BuySqrButtonProps = ComponentPropsWithoutRef<'button'> & { label?: string };

export const BuySqrButton = forwardRef(
  ({ className, label = 'SQR', ...props }: BuySqrButtonProps, ref: Ref<HTMLButtonElement>) => {
    const { data } = useSqrTokenPriceQuery({
      refetchInterval: TimeIntervalsInMilliseconds.MINUTES_10,
    });

    const formattedSqrPrice = data ? formatUsd(data.attributes.price) : null;

    return (
      <button
        ref={ref}
        className={cn('msq-btn msq-btn-md msq-btn-brand-gradient !rounded-full gap-1.5', className)}
        {...props}
      >
        <Sqr className="msq-btn-icon-child" />
        {label}
        <span
          className={cn('min-w-10', {
            'msq-skeleton-text': !formattedSqrPrice,
          })}
        >
          {formattedSqrPrice}
        </span>
      </button>
    );
  },
);
